export class Cookie {
    static set(name, value, options = {}) {
        let cookieString = `${name}=${value}`;
        if (options.path) {
            cookieString += `; path=${options.path}`;
        }
        if (options.expires) {
            cookieString += `; expires=${options.expires.toUTCString()}`;
        }
        else if (options.maxAge) {
            cookieString += `; max-age=${options.maxAge}`;
        }
        if (typeof window !== 'undefined') {
            document.cookie = cookieString;
        }
    }
    static get(name) {
        if (typeof window === 'undefined') {
            return null;
        }
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=').map((c) => c.trim());
            if (cookieName === name) {
                return cookieValue ?? null;
            }
        }
        return null;
    }
    static remove(name, path = '/') {
        if (typeof window !== 'undefined') {
            document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        }
    }
    static setAuthTokens(accessToken, refreshToken) {
        // Set access token to expire in 7 days
        const accessTokenExpires = new Date();
        accessTokenExpires.setDate(accessTokenExpires.getDate() + 7);
        // Set refresh token to expire in 30 days
        const refreshTokenExpires = new Date();
        refreshTokenExpires.setDate(refreshTokenExpires.getDate() + 30);
        this.set('access_token', accessToken, {
            path: '/',
            expires: accessTokenExpires,
        });
        this.set('refresh_token', refreshToken, {
            path: '/',
            expires: refreshTokenExpires,
        });
    }
    static removeAuthTokens() {
        this.remove('access_token');
        this.remove('refresh_token');
    }
    static setRedirectingUrl(url) {
        // Don't save auth pages as redirecting URL
        if (url.startsWith('/auth/') || url.includes('/auth/')) {
            return;
        }
        // Don't save home page as redirecting URL
        if (url === '/' || url === '/fa' || url === '/en') {
            return;
        }
        // Strip locale prefix only when present (/en/... or /fa/...)
        const locales = ['en', 'fa'];
        const hasLocalePrefix = locales.some((locale) => url.startsWith(`/${locale}/`));
        const pathToSave = hasLocalePrefix ? url.slice(3) : url;
        this.set('redirecting_url', pathToSave, { path: '/' });
    }
    static getRedirectingUrl() {
        return this.get('redirecting_url');
    }
    static clearRedirectingUrl() {
        this.remove('redirecting_url');
    }
}
